export const environment = {
    production: true,
    customerName: "Vibgyor",
    productName: "HRMS",
    companyId: 1,
    faviconPath: "assets/company/vibgyor/favicon.png",
    logoPath: "assets/company/vibgyor/VibgyorLogo.png",
    backend: {
        baseURL: "https://api.vibgyor.co.in/api/",
        imageURL: "https://api.vibgyor.co.in/"
        // baseURL: "https://api-dev.vibgyor.co.in/api/",
        // imageURL: "https://api-dev.vibgyor.co.in/"
        // baseURL: "https://localhost:7104/api/",
        // imageURL: "https://localhost:7104/"
    }
};